export const TERMS_OF_USE_FOR_JOB_NAME = "TermsOfUseForJob";
export const TERMS_OF_USE_FOR_PLAN_NAME = "TermsOfUseForPlan";
export const TERMS_OF_USE_FOR_SCOUT_NAME = "TermsOfUseForScout";
export const TERMS_OF_USE_FOR_AGENT_SCOUT_NAME = "TermsOfUseForAgentScout";
export const TERMS_OF_OUTSOURCING_NAME = "TermsOfOutsourcing";
export const TERMS_OF_USE_FOR_AGENT_NAME = "TermsOfUseForAgent";
export const TERMS_OF_USE_FOR_LEASE_NAME = "TermsOfUseForLease";
export const TERMS_OF_SUBCONTRACTING_NAME = "TermsOfSubcontracting";
export const TERMS_OF_USE_FOR_ADVERTORIAL_NAME = "TermsOfUseForAdvertorial";
export const TERMS_OF_USE_FOR_ONLINE_EVENT_NAME = "TermsOfUseForOnlineEvent";
export const TERMS_OF_USE_FOR_MOVIE_NAME = "TermsOfUseForMovie";
export const TERMS_OF_USE_FOR_EVENT_APPLICATION_NAME =
  "TermsOfUseForEventApplication";
export const TERMS_OF_USE_FOR_MOVIE_PRODUCTION = "TermsOfMovieProduction";
export const EXTERNAL_DATA_PROCESSORS = "ExternalDataProcessors";
